import http_request from './http_request'
import config from 'config'

function getOEQData(device_uid, slide, headers) {
	return http_request.post(config.hub + 'session/poll')
		.withHeaders(headers)
		.send({
			device_uid,
			slide,
		})
}

export {
	getOEQData,
}
